export default __webpack_public_path__ + "static/media/slider1.fc0d5c04.jpeg";